import type { TFunction } from 'i18next';

/**
 * Display labels for the marketplace wire enums. Spelled out as literal
 * t() calls so the i18n checker sees every key; an unknown value (the
 * backend adding an enum member first) falls back to the raw value.
 */
export const enumLabel = (t: TFunction, value: string): string => {
  const labels: Record<string, string> = {
    // issue_type
    employment: t('Employment'),
    tenancy: t('Tenancy'),
    family: t('Family'),
    contract: t('Contract'),
    corporate: t('Corporate'),
    debt: t('Debt'),
    immigration: t('Immigration'),
    other: t('Other'),
    // urgency
    low: t('Low'),
    medium: t('Medium'),
    high: t('High'),
    // scope size
    small: t('Small'),
    large: t('Large'),
    // fee basis
    fixed: t('Fixed fee'),
    capped: t('Capped fee'),
    hourly: t('Hourly'),
    milestone: t('Milestone'),
    // lead / proposal status
    draft: t('Draft'),
    triaged: t('Triaged'),
    sent: t('Sent'),
    proposed: t('Proposed'),
    engaged: t('Engaged'),
    declined: t('Declined'),
    closed: t('Closed'),
    countered: t('Countered'),
    accepted: t('Accepted'),
    withdrawn: t('Withdrawn'),
  };
  return labels[value] ?? value;
};
